// extracted by mini-css-extract-plugin
export default {"toggleBtn":"ToggableSection_toggleBtn__j00Gn","toggleBtnOpened":"ToggableSection_toggleBtnOpened__5pxS+"};